import * as XLSX from "xlsx";

const stamp = () => new Date().toISOString().slice(0, 16).replace(/[-:T]/g, "");

export function downloadRows(rows, name = "fundle-brain") {
  const ws = XLSX.utils.json_to_sheet(rows.map((r) => Object.fromEntries(Object.entries(r).map(([k, v]) => [k.replace(/_/g, " "), v !== null && typeof v === "object" ? JSON.stringify(v) : v]))));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Data");
  XLSX.writeFile(wb, `${name}-${stamp()}.xlsx`);
}

export function downloadTable(el, name = "fundle-brain-answer") {
  const ws = XLSX.utils.table_to_sheet(el, { raw: true });
  Object.keys(ws).filter((k) => !k.startsWith("!")).forEach((k) => {
    const c = ws[k];
    const t = typeof c.v === "string" ? c.v.replace(/[₹,\s]/g, "").replace(/%$/, "") : null;
    if (t && /^-?\d+(\.\d+)?$/.test(t)) { c.v = Number(t); c.t = "n"; }
  });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Answer");
  XLSX.writeFile(wb, `${name}-${stamp()}.xlsx`);
}
